/************************************
MODULE:         Tracking
WHAT IT DOES:   Provides with all functionality that relates to tracking
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    var settings = { handlerUrl: "logactivity.ashx" };

    function init() {
        initClickActivity();

        $(document).on('activity.logger:reinit', reinit);
    }

    function reinit() {
        remove();

        init();
    }

    function remove() {
        removeClickActivity();
    }

    function initClickActivity() {
        $(document).on('click', '.js-log-activity', eventProcess);
    }

    function removeClickActivity() {
        $(document).off('click', '.js-log-activity');
    }

    function eventProcess(e) {
        if (typeof e != 'undefined' && typeof e.stopPropagation == "function") {
            e.stopPropagation();
        }

        var control = $(this);
        if (control.hasClass('js-log-activity-done')) return;

        sendActivity(control.attr('data-activity-name'), control.attr('data-activity-title'));
        control.addClass('js-log-activity-done');
    }

    function sendActivity(name, title) {
        $.ajax({
            url: settings.handlerUrl,
            type: "POST",
            data: { activity_name: name, activity_title: title, activity_url : window.location.origin + window.location.pathname },
            dataType: "JSON",
            async: true
        }).done(function (results) {
            console.log(results);
        });
    }

    return {
        init: init
    };
}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.activitylogger.js
 ** module id = 32
 ** module chunks = 24
 **/